<template>
  <div>
    <div
      v-if="$route.name === 'user-profile' && !requestData.respuestaAvanzada.activa"
    >
      <p class="message-info" >
        Sin firma configurada dentro de la empresa, contáctese con su administrador
      </p>
    </div>
    <div
      :class="{ 'sign-container': $route.name === 'user-profile'}"
      v-if="!exitMessage">
      <h5 class="message mb-5">
        La contraseña ingresada se utiliza para firmar documentos y el nombre
        identificador se necesita para poder encontrar el certificado en Ministerio de Economía.
      </h5>
      <!-- ESTADO DE LA FIRMA -->
      <div class="row mb-2" v-if="requestData.id">
        <vs-icon class="col-1" icon="adjust"></vs-icon>
        <label class="col-3 text-left">Estado de firma:</label>
        <b-form-checkbox
          v-if="$route.name === 'users-management'"
          class="col-1 ml-4"
          v-model="signData.active"/>
        <label class="col-2 text-left">({{signData.active ? 'Activa' : 'Inactiva'}})</label>
      </div>
      <!-- NOMBRE IDENTIFICADOR -->
      <div class="row mb-2">
        <vs-icon class="col-1" icon="fingerprint"></vs-icon>
        <label class="col-3 text-left">Nombre identificador:</label>
        <div class="col-8">
          <b-form-select
            :options="getSigners"
            :disabled="$route.name === 'user-profile'"
            v-model="signData.userSignature"
            :state="$route.name === 'users-management' ? validateIndentifier : null"
          />
             <b-form-invalid-feedback
              v-if="$route.name === 'users-management'"
              :state="validateIndentifier">
              El identificador es obligatorio
            </b-form-invalid-feedback>
        </div>
      </div>
      <!-- CONTRASEÑA CERTIFICADO -->
      <div class="row mb-4">
        <vs-icon class="col-1" icon="lock"></vs-icon>
        <label class="col-3 text-left">Contraseña certificado:</label>
        <div class="col-8">
          <b-form-input
            maxlength="100"
            :state="$route.name === 'user-profile' ? validatePassword : null"
            :disabled="$route.name === 'users-management'"
            type="password" v-model="signData.hash"
          />
          <b-form-invalid-feedback
            v-if="$route.name === 'user-profile'"
            :state="validatePassword">
            Mínimo 6 caracteres
          </b-form-invalid-feedback>
        </div>
      </div>
      <!-- BOTON -->
      <div class="row d-block text-center">
        <b-button
          :disabled="loading"
          :variant="signData.id ? 'primary' : 'warning'"
          @click="saveSignature"
        >
          {{ signData.id ? 'Guardar cambios' : 'Activar firma' }}
          <b-spinner small v-if="loading" variant="primary"/>
        </b-button>
      </div>
    </div>
    <div
      class="text-center alert alert-success p-3"
      role="alert"
      v-show="exitMessage && $route.name === 'users-management'"
    >
      Identificador de firma grabado exitosamente. Puede cerrar esta ventana
    </div>
    <!-- Configuración de estampa -->
    <div v-if="requestData.id && $route.name === 'user-profile'" class="mt-4">
      <ConfigureStamp
        prefix="ecert"
        proveedor="FirmadorMinisterioEconomia"
        tipoFirma="firmaAvanzada"
        :user="user"
        :customConfigIds="{
          tipo: 'io.febos.ecert.tipo',
          plantilla: 'io.febos.ecert.plantilla',
          imagen: 'io.febos.ecert.imagen',
          background: 'io.febos.ecert.background',
          representacion: 'io.febos.ecert.representacion',
          alto: 'io.febos.ecert.alto',
          ancho: 'io.febos.ecert.ancho'
        }"
      />
    </div>
  </div>
</template>

<script>
import { configureAdvancedSign } from '@/febos/servicios/api/usuarios.api';
import ConfigureStamp from '@/febos/global/usuario/components/sign/shared/ConfigureStamp';

export default {
  name: 'AvanzadaSignFirmadorministerioeconomia',
  components: { ConfigureStamp },
  data() {
    return {
      exitMessage: null,
      loading: false,
      signData: {
        id: null,
        active: null,
        userSignature: null,
        hash: null,
      }
    };
  },
  created() {
    this.signData.id = this.requestData.id;
    this.signData.active = this.requestData.respuestaAvanzada.activa;
    this.signData.userSignature = this.requestData.respuestaAvanzada.usuarioFirma;
    this.signData.hash = this.requestData.respuestaAvanzada.hash;
  },
  computed: {
    validatePassword() {
      return this.signData.hash?.length >= 6;
    },
    validateIndentifier() {
      return this.signData.userSignature != null;
    },
    getSigners() {
      return this.requestData.respuestaAvanzada.firmantes.map((firmante) => ({
        value: firmante,
        text: firmante
      }));
    }
  },
  methods: {
    async saveSignature() {
      if (!this.validatePassword && this.$route.name === 'user-profile') {
        return;
      }
      if (!this.validateIndentifier && this.$route.name === 'users-management') {
        return;
      }
      this.loading = true;
      const data = {
        idUsuarioFirma: this.user.id,
        proveedor: 'FirmadorMinisterioEconomia',
        tipoFirma: 'firmaAvanzada',
        requestEconomia: {
          id: this.signData.id,
          activa: this.signData.active,
          identificador: this.signData.userSignature,
          hash: this.signData.hash
        },
      };
      try {
        await configureAdvancedSign(data);
        this.exitMessage = true;
        if (this.$route.name === 'user-profile') {
          this.$emit('activate');
        }
        this.loading = false;
      } catch {
        this.loading = false;
      }
    }
  },
  props: {
    user: { type: Object },
    signConfiguration: { type: Object },
    requestData: { type: Object },
  },
};
</script>
<style scoped>
.sign-container {
  padding: 0 200px;
}
.message-info {
  color: white;
  font-weight: normal;
  background: #ea7037;
  border-radius: 10px 10px 10px 10px;
  padding: 10px;
}
</style>
